// extracted by mini-css-extract-plugin
module.exports = {"MuiAutoCompleteRoot":"UserPartnerSelect_MuiAutoCompleteRoot__3S4c8","MuiListboxComponent":"UserPartnerSelect_MuiListboxComponent__6qk5m"};